// Journal des exports (spec § 2) : chaque fichier produit par l'interface laisse une ligne par `log_export`.
import type { Exporter } from "ra-core";

import { getSupabaseClient } from "../providers/supabase/supabase";

export const MAX_EXPORT_ROWS = 5000;

export type ExportFormat = "csv" | "xlsx";

/** Journal des exports : l'échec de l'écriture est signalé, le fichier est déjà enregistré. */
export const logExport = async (
  resource: "projects" | "deals" | "contacts" | "companies",
  format: ExportFormat,
  rowCount: number,
  filters: Record<string, unknown> = {},
) => {
  const { error } = await getSupabaseClient().rpc("log_export", {
    resource,
    format,
    row_count: rowCount,
    filters,
  });
  if (error) throw error;
};

/** Exporteur d'atomic-crm (contacts, sociétés) complété d'une ligne au journal des exports. */
export const loggedExporter =
  (resource: "contacts" | "companies", exporter: Exporter): Exporter =>
  async (data, ...rest) => {
    await exporter(data, ...rest);
    await logExport(resource, "csv", data.length);
  };
